//#region src/core/i18n/locales/lt.ts
var lt_default = {
	buttons: {
		play: "Leisti",
		pause: "Pristabdyti",
		replay: "Leisti iš naujo",
		mute: "Išjungti garsą",
		unmute: "Įjungti garsą"
	},
	seek: {
		forward: "Persukti pirmyn {seconds} sek.",
		backward: "Persukti atgal {seconds} sek."
	},
	fullscreen: {
		enter: "Visas ekranas",
		exit: "Išeiti iš viso ekrano"
	},
	captions: {
		enable: "Įjungti subtitrus",
		disable: "Išjungti subtitrus"
	},
	pip: {
		enter: "Vaizdas vaizde",
		exit: "Išjungti vaizdą vaizde"
	},
	live: {
		playing: "Rodoma tiesiogiai",
		seekToEdge: "Pereiti prie tiesioginės transliacijos",
		badge: "Tiesiogiai"
	},
	cast: {
		start: "Pradėti perdavimą",
		stop: "Stabdyti perdavimą",
		connecting: "Prisijungiama"
	},
	airplay: {
		start: "Įjungti AirPlay",
		stop: "Išjungti AirPlay"
	},
	slider: { seek: "Persukimas" },
	time: {
		current: "Dabartinis laikas",
		duration: "Trukmė",
		remaining: "Likęs laikas",
		elapsedSuffix: "{duration} praėjusio laiko",
		durationSuffix: "{duration} trukmės",
		remainingSuffix: "Liko {duration}",
		showElapsed: "Rodyti praėjusį laiką, {duration}.",
		showDuration: "Rodyti trukmę, {duration}.",
		showRemaining: "Rodyti likusį laiką, {duration}.",
		toggleElapsed: "Perjungti praėjusį ir likusį laiką.",
		toggleDuration: "Perjungti trukmę ir likusį laiką.",
		position: "{current} / {duration}",
		unknown: "Medija neįkelta, laikas nežinomas."
	},
	playback: { rate: "Atkūrimo greitis {rate}" },
	volume: {
		mutedValue: "{percent}, garsas išjungtas",
		muted: "Garsas išjungtas",
		label: "Garsumas",
		value: "Garsumas {value}"
	},
	status: {
		captionsOn: "Subtitrai įjungti",
		captionsOff: "Subtitrai išjungti",
		paused: "Pristabdyta",
		playing: "Leidžiama",
		fullscreen: "Visas ekranas",
		pip: "Vaizdas vaizde",
		exitPip: "Vaizdas vaizde išjungtas",
		seekedTo: "Persukta: {time}"
	},
	container: { label: "Medijos leistuvė" },
	errors: {
		aborted: "Sustabdėte atkūrimą jam dar nepasibaigus.",
		network: "Šios medijos nepavyko įkelti dėl tinklo arba serverio klaidos.",
		decode: "Šios medijos nepavyko atkurti. Ji gali būti sugadinta arba naršyklė nepalaiko jos formato.",
		source: "Šios medijos nepavyko įkelti. Ji gali būti nepasiekiama arba naršyklė nepalaiko jos formato.",
		encrypted: "Šios medijos nepavyko atkurti, nes nepavyko jos iššifruoti.",
		unplayable: "Leistuvė nepalaiko šios medijos.",
		title: "Kažkas nutiko ne taip.",
		unexpected: "Įvyko nenumatyta klaida."
	},
	common: {
		empty: "",
		ok: "Uždaryti"
	},
	menu: {
		settings: "Nustatymai",
		quality: "Kokybė",
		audio: "Garso takelis",
		default: "Numatytasis",
		speed: "Greitis",
		captions: "Subtitrai",
		playbackRate: "Atkūrimo greitis",
		back: "Atgal",
		off: "Išjungta",
		auto: "Automatinė",
		autoWithLabel: "Automatinė ({label})",
		subtitles: "Subtitrai"
	}
};
//#endregion
export { lt_default as default };

//# sourceMappingURL=lt.js.map